// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function conversationVisibilityV5_decode($$enum) {
  if ($$enum === "PRIVATE" || $$enum === "PUBLIC") {
    return $$enum;
  }
}

let conversationVisibilityV5_fromString = conversationVisibilityV5_decode;

let Utils = {
  conversationVisibilityV5_decode: conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: conversationVisibilityV5_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageConversationMessagesMessage_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    }
  ],
  "type": "ConversationV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
